import type { TableProps as MantineTableProps } from '@mantine/core';
import { Table } from '@mantine/core';

import classes from './Table.module.css';

const TableDefaults = Table.extend({
  defaultProps: {
    highlightOnHover: true,
    highlightOnHoverColor: 'cobalt.7',
    stickyHeader: true,
    fz: 'xs',
    // setting verticalSpacing (7px by default) to 0px allows each td to span the height set by tr
    // spacing displayed in design will be matched with default line-height applied to td
    verticalSpacing: 0,
  },
  classNames: {
    table: classes.table,
    thead: classes.thead,
    tr: classes.tr,
    td: classes.td,
  },
});

export { Table as MantineTable, TableDefaults };
export type { MantineTableProps };
